app.controller(
    'UserEditController', ['$scope', '$state', '$stateParams', 'Api', 'BoxLoading', 'Configuration', 'FormApiErrorHandler', UserEditController]
);

function UserEditController($scope, $state, $stateParams, Api, BoxLoading, Configuration, FormApiErrorHandler) {
    if ($stateParams.id) {
        $scope.mode = 'edit';
        $scope.apiUrl = '/user/' + $stateParams.id + '/edit';
    } else {
        $scope.mode = 'create';
        $scope.apiUrl = '/user/add';
    }

    $scope.assetUrl = Configuration.assets.url;

    $scope.user = {
        id : null,
        lastName : '',
        firstName : '',
        phone : '',
        role : 'ROLE_USER',
        status : '0',
        email : '',
        password : '',
        deletePhoto : false
    };
    $scope.userPhoto = null;

    $scope.$on(
        '$viewContentLoaded', function () {
            if ($scope.mode == 'edit') {
                BoxLoading.start('.edit-box');

                Api.post('/user/' + $stateParams.id).then(
                    function (response) {
                        BoxLoading.stop('.edit-box');

                        if (response.data.result.user) {
                            $scope.user = response.data.result.user;
                            $scope.user.status = $scope.user.status.toString();
                        } else {
                            alert('Une erreur serveur est survenue !');
                            $state.go('app.user.datatable');
                        }
                    }
                );
            }
        }
    );

    $scope.submit = function () {
        BoxLoading.start('.edit-box');

        var success = function (response) {
            BoxLoading.stop('.edit-box');

            if (response.data.result) {
                $state.go('app.user.datatable');
            } else {
                FormApiErrorHandler.handle($('.user-edit-form'), response.data.errors);
            }
        };

        if ($scope.userPhoto) {
            var formData = new FormData();
            formData.append('data', angular.toJson($scope.user));
            formData.append('photo', $scope.userPhoto);
            Api.postMultipart($scope.apiUrl, formData).then(success);
        } else {
            Api.post($scope.apiUrl, $scope.user).then(success);
        }
    };
}



